import React, { useEffect, useMemo, useRef, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiTextArea, EuiButton, EuiSpacer, EuiTextColor, EuiSwitch, EuiText} from '@elastic/eui';
import SelectorFecha from '../../../../../../shared/Components/Selectores/Fecha';
import {SelectorPeriodosContainer as SelectorPeriodos} from '../../../../components/Selectores/Periodos/container';
import {SelectorEstadosPeriodo} from '../../../../components/Selectores/EstadosPerido/selector';
import ContenidosPeriodo from '../ContenidosInformes/contenidos';
import { CreateFechaMoment, ToSQL } from '../../../../../../shared/utils/fecha';
import './styles.css';


export const Formulario = (props)=>{

  const ref = useRef();
  const {onSave, data, selected, ejercicio, onClose} = props

  const [periodo,setPeriodo] = useState(selected ? selected.periodo : undefined)
  const [reunion,setReunion] = useState(selected ? selected.reunion : undefined)
  const [fechaDesde, setFechaDesde] = useState(selected && selected.fDesde != null ? CreateFechaMoment(selected.fDesde) : null)
  const [fechaHasta, setFechaHasta] = useState(selected && selected.fHasta != null ? CreateFechaMoment(selected.fHasta) : null)
  const [comentario, setComentario] = useState(selected ? selected.comentario : undefined);
  const [estado, setEstado] = useState(selected ? selected.estado : 'Sin Iniciar');
  const [contenidos, setContenidos] = useState(selected ? selected.contenidos : []);
  const [mesCambio,setMesCambio] = useState(selected ? selected.mesCambio : undefined)
  const [escCARPDT,setEscCARPDT] = useState(selected ? selected.escCARPDT : false)
  const [mesCART,setMesCART] = useState(selected ? selected.mesCART : undefined)

  const getData = () =>{
    let data = { año: parseInt(ejercicio), periodo: periodo, reunion: reunion, estado: estado, 
      comentarios: comentario, fDesde: (fechaDesde!==null ? ToSQL(fechaDesde,'-') : fechaDesde), 
      fHasta: (fechaHasta!==null ? ToSQL(fechaHasta,'-') : fechaHasta), contenidos: contenidos, MesCambio : parseInt(mesCambio), escCARPDT: escCARPDT, mesCART: parseInt(mesCART)}
    if(selected){
      return {...selected,...data}
    }else{
      return data
    }
  }

  const onSaveData = () =>{
    if(!comprobarErrores()){
      let newData = getData();
      onSave && onSave(newData)
    }
  }

  const onChangePeriodo = (value) =>{
    setPeriodo(value.idTipoPeriodo)
    setReunion(value.tipoPeriodo)
    setContenidos([]);
  }

  // useEffect(()=>{
  //   console.log('useEffect contenidos', contenidos);
  // }, [contenidos]);

  const onChangeContenido = (contenido)=>{
    if(periodo!==4 && periodo!==1){
      let newData = [contenido];
      setContenidos([...newData]);
    }else{
      let pos = contenidos.findIndex((c) => c.idTipoContenido === contenido.idTipoContenido);
      if(pos>=0){
        let newData = [ ...contenidos ];
        newData[pos] = contenido;
        setContenidos([ ...newData ]);
      }else{
        let newData = [ ...contenidos ];
        newData.push(contenido);
        setContenidos([...newData])
      }
    }
  }

  const comprobarErrores = () => {
    return (isInvalidPeriodo)
  }

  const isInvalidPeriodo = useMemo(() => {return periodo===undefined},[periodo])
  const isInvalidReunion = useMemo(() => {return reunion===undefined},[reunion])

  const isInvalidMesCambio = useMemo(() => {return mesCambio===undefined || !(/^-?\d+$/.test(mesCambio)) || parseInt(mesCambio) < 1 || parseInt(mesCambio) > 12},[mesCambio])
  const isInvalidMesCART = useMemo(() => {return (escCARPDT ? false : (mesCART===undefined || !(/^-?\d+$/.test(mesCART)) || parseInt(mesCART) < 1 || parseInt(mesCART) > 12))},[mesCART, escCARPDT])

  const disabledData = useMemo(() =>{
    if(selected===undefined){return data.map((d)=> d.periodo)}
  },[data])
  
  return (
    <>
    <h1 className='ejercicio-titulo-form'>{`EJERCICIO ${ejercicio}`}</h1>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Periodo" isInvalid={isInvalidPeriodo}>
          <SelectorPeriodos fullWidth disabled={selected?true:false} disabledData={disabledData} valueOfSelected={periodo} onChange={value => onChangePeriodo(value)} getText isInvalid={isInvalidPeriodo} año={ejercicio}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Reunión" isInvalid={isInvalidReunion}>
          <EuiFieldText fullWidth value={reunion} name="txtReunion" onChange={e => setReunion(e.target.value)} isInvalid={isInvalidReunion}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Estado">
          <SelectorEstadosPeriodo fullWidth disabled valueOfSelected={estado} onChange={value => setEstado(value)}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Fecha Desde">
          <SelectorFecha fullWidth selected={fechaDesde} onChange={date => setFechaDesde(date)} onClear={() => setFechaDesde(null)}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Fecha Hasta">
            <SelectorFecha fullWidth selected={fechaHasta} onChange={date => setFechaHasta(date)} onClear={() => setFechaHasta(null)}/>
          </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Mes Tipo Cambio"  isInvalid={isInvalidMesCambio}>
          <EuiFieldText fullWidth value={mesCambio} name="txtTipoCambio" onChange={e => setMesCambio(e.target.value)}  isInvalid={isInvalidMesCambio}/>
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="escCARPDT">
          <EuiSwitch label="escCARPDT" checked={escCARPDT} onChange={(e)=> {setEscCARPDT(!escCARPDT); setMesCART(0);}} />      
        </EuiFormRow>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="Mes CART"  isInvalid={isInvalidMesCART}>
          <EuiFieldText fullWidth value={mesCART} name="txtMesCART" onChange={e => setMesCART(e.target.value)}  isInvalid={isInvalidMesCART} disabled={escCARPDT}/>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    <EuiFlexGroup>
        <EuiFlexItem>
          <EuiFormRow fullWidth label="Comentario">
            <EuiTextArea
              compressed
              fullWidth
              value={comentario}
              onChange={(e) => setComentario(e.target.value)}
            />
          </EuiFormRow>
        </EuiFlexItem>
    </EuiFlexGroup>
    <ContenidosPeriodo refForm={ref} periodo={periodo} ejercicio={ejercicio} data={contenidos} onChangeContenido={onChangeContenido} isUpdate={selected?true:false}/>

    {comprobarErrores() ? 
    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiFormRow fullWidth label="">
          <EuiTextColor color="danger"><br/>{"Faltan campos por rellenar"}</EuiTextColor>
        </EuiFormRow>
      </EuiFlexItem>
    </EuiFlexGroup>
    :null}
    <EuiSpacer size="m" />

    <EuiFlexGroup>
      <EuiFlexItem>
        <EuiButton onClick={onSaveData} disabled={comprobarErrores()}>
          Guardar
        </EuiButton>
      </EuiFlexItem>
      <EuiFlexItem>
        <EuiButton color="danger" onClick={()=>onClose()}>Cancelar</EuiButton>
      </EuiFlexItem>
    </EuiFlexGroup>
    </>
      
  )
}
export default Formulario;